import { Box, HStack, Icon, Shadow, TableItem, Text, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Button } from 'native-base';
import React from 'react';

import { movementWidthCols } from '../TableHead/constants';

import { ItemResponsiveProps } from '.';

export const DesktopItem: React.FC<ItemResponsiveProps> = ({
  asset,
  descriptionType,
  description,
  requestedDate,
  settlementDate,
  formattedValue,
  quantity,
  valueIsPositive,
  statusIcon,
  statusDescription,
  cancelButtonIsDisabled,
  productType,
  handleCancelMovement,
}) => {
  const isTreasury = productType === 'Treasury';

  return (
    <Shadow borderRadius={BoxBorder.heavy} level={3} my="stack.nano">
      <HStack alignItems="center" w="full" py="inline.xxxs" borderRadius={BoxBorder.heavy}>
        <TableItem
          testId="movement-requested-date-item"
          width={movementWidthCols.requestDate.desktop}>
          <Text fontSize="xs" color="neutral.black">
            {requestedDate}
          </Text>
        </TableItem>
        <TableItem
          testId="movement-settlement-date-item"
          width={movementWidthCols.settlementDate.desktop}>
          <Text fontSize="xs" color="neutral.black">
            {settlementDate}
          </Text>
        </TableItem>
        <TableItem testId="movement-description-item" width={movementWidthCols.description.desktop}>
          <VStack space="stack.quarck">
            <Text fontSize="xs" color="neutral.black" variant="bold">
              {descriptionType}
            </Text>
            <Text fontSize="xs" color="neutral.black">
              {description}
            </Text>
          </VStack>
        </TableItem>
        <TableItem testId="movement-value-item" width={movementWidthCols.value.desktop}>
          {isTreasury ? (
            <VStack space="stack.quarck">
              <Text fontSize="xs" color="neutral.black" variant="bold">
                {formattedValue}
              </Text>
              <Text fontSize="xs" color="neutral.black">
                Quantidade {quantity}
              </Text>
            </VStack>
          ) : (
            <Text
              fontSize="xs"
              color={valueIsPositive ? 'feedback.success.default' : 'feedback.error.default'}>
              {formattedValue}
            </Text>
          )}
        </TableItem>
        <TableItem testId="movement-asset-item" width={movementWidthCols.asset.desktop}>
          <Text fontSize="xs" color="neutral.black">
            {asset}
          </Text>
        </TableItem>
        <TableItem testId="movement-status-item" width={movementWidthCols.status.desktop}>
          <HStack w="full" alignItems="center" space="stack.quarck">
            {statusIcon}
            <Text fontSize="xs" color="neutral.black">
              {statusDescription}
            </Text>
          </HStack>
        </TableItem>
        <TableItem
          testId="movement-cancellation-item"
          width={movementWidthCols.cancellation.desktop}>
          <Box w="full">
            <Button
              variant="textLink"
              onPress={handleCancelMovement}
              isDisabled={cancelButtonIsDisabled}
              _disabled={{
                _text: {
                  color: 'neutral.light',
                },
              }}
              _text={{ color: 'feedback.error.default' }}
              endIcon={
                <Icon
                  testID="cancel-button-icon"
                  name={'Trash'}
                  size="xxs"
                  color={cancelButtonIsDisabled ? 'neutral.light' : 'feedback.error.default'}
                />
              }>
              Cancelar
            </Button>
          </Box>
        </TableItem>
      </HStack>
    </Shadow>
  );
};
